import ProductsApi from 'lib/api/products'
import StateStorage from 'lib/state-storage'
import { segmentTrackProductListViewed } from 'lib/segment'
import {
  SEGMENT_STORAGE_KEY_CATEGORY,
  SEGMENT_STORAGE_KEY_SSR,
} from 'lib/segment/const'

const SIMILAR_PRODUCT_LIMIT = 18
const shop = StateStorage.getShop()
const lang = StateStorage.getLanguage()

/**
 * @param {number} productId - ID product
 * @param {number[]} productIdList - List of ids of similar products
 * @param {number} pageNo - Page number
 */
export const trackProductListViewedWithRef = (
  productId,
  productIdList,
  pageNo,
  refType = null,
  refId = null,
) => {
  const click_position = sessionStorage.getItem(
    SEGMENT_STORAGE_KEY_CATEGORY.position,
  )
  const sub_position = sessionStorage.getItem(
    SEGMENT_STORAGE_KEY_CATEGORY.subPos,
  )
  sessionStorage.removeItem(SEGMENT_STORAGE_KEY_CATEGORY.position)
  sessionStorage.removeItem(SEGMENT_STORAGE_KEY_CATEGORY.subPos)
  const shouldSendIdCategory = refType?.includes('just_for_you')

  const ref = {
    click_position,
    ref_id: refId || productId,
    ref_type: refType || 'category_similar_products',
    sub_position,
  }

  /* Note: we must apply this condition to avoid sending multiple events upon the first page landing.
  This is necessary as there is also an event trigger on the categoryList components. */
  if (pageNo > 1) {
    segmentTrackProductListViewed(
      {
        page_number: pageNo,
        product_list_ids: productIdList,
        ...(shouldSendIdCategory && { id_site_category: 111 }),
      },
      ref,
    )
  }

  sessionStorage.setItem(SEGMENT_STORAGE_KEY_SSR, '1')
}

/**
 * @param {Object} options - Function options
 * @param {number} options.productId - Id of product to get similar items
 * @param {number} options.skip - Number of products to skip
 * @returns {Object} - Object containing products array and product id
 */
export const getSimilarProduct = async ({ productId, skip }) => {
  try {
    const similarProducts = await ProductsApi.getSimilarsByProduct({
      productId,
      shop,
      lang,
      skip,
      limit: SIMILAR_PRODUCT_LIMIT,
    })

    if (similarProducts?.length) {
      const similarIds = similarProducts.map((item) => +item.id_product)
      return {
        products: similarProducts,
        productId,
        similarIds,
      }
    }

    return { products: null }
  } catch (err) {
    return { error: true, ...err }
  }
}

/**
 * @param {Object} options - Function options
 * @param {number} options.productId - Id of product
 * @param {number} pageNo - Page number
 * @param {number} skip - Number of products to skip
 * @param {Function} onSuccess - Success callback
 * @param {Function} onError - Error callback
 */
export const fetchSimilarProducts = async ({
  productId,
  pageNo,
  skip,
  onSuccess,
  onError,
}) => {
  const res = await getSimilarProduct({
    productId,
    shop,
    lang,
    skip,
  })

  if (res?.products && onSuccess) {
    onSuccess(res?.products)
    trackProductListViewedWithRef(productId, res.similarIds, pageNo + 1)
  } else {
    onError(res?.error)
  }
}
